import type { AttachmentType } from 'pkg/api/models/attachment';
import type { Dateable } from 'pkg/api/models/dateable';
import type { FieldTypes } from 'pkg/api/models/form';
import type { FormFieldOption } from 'pkg/api/models/form_field_option';
import type { Record } from 'pkg/api/models/record';

export interface FieldValue {
	value: string;
	label: string;
	maxSubmissions?: number;
}

export interface FormField extends Dateable, Record {
	key: string;
	type: FieldTypes;
	label: string;
	description?: string;
	values?: FieldValue[];
	sortOrder?: number;
	required?: boolean;
	deletedAt?: number;
	userFieldId?: number;
	attachmentType?: AttachmentType;
	options?: FormFieldOption[];
	displayAsDropdown?: boolean;
	tempId?: string;
}

export interface FieldRef {
	id?: number | null;
	tempId?: string | null;
}

/**
 * Why an eligibility rule can no longer be saved against the current form fields. Maps 1:1 to the
 * backend rejections in form_package_rules_validate.go (field not found, field not required, option
 * not found). A rule's references drift when the questions section is edited after the rule was
 * created — the backend then hard-rejects the save, so the editor surfaces this and blocks saving
 * until the user removes the rule.
 */
export enum RuleFieldError {
	FieldMissing = 'field_missing',
	FieldNotRequired = 'field_not_required',
	OptionsMissing = 'options_missing',
}
